import React from 'react';

import { Select } from 'ui/base';

import useCountries from './useCountries';

const DEFAULT_VALUE_FIELD = 'code';

const CountrySelect = React.forwardRef(
  ({ defaultOption, overriddenOptions, valueField = DEFAULT_VALUE_FIELD, ...rest }, ref) => {
    const { formatted, loading } = useCountries({ valueField, overriddenOptions });

    const options = React.useMemo(
      () => (defaultOption ? [{ ...defaultOption, default: true }, ...formatted] : formatted),
      [defaultOption, formatted]
    );

    return (
      <Select
        ref={ref}
        withSearch
        {...rest}
        loading={loading}
        options={options}
        fieldNames={{ value: valueField }}
      />
    );
  }
);

export default CountrySelect;
